export const fetchHtmlPage = async (href: string, signal: AbortSignal): Promise<string> => {
  const response = await fetch(href, {
    method: 'GET',
    credentials: 'same-origin',
    signal,
  });

  if (!response.ok) {
    const error = new Error(`Dashboard navigation failed (${response.status})`) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }

  return response.text();
};

type AvatarRequestPayload = {
  endpoint: string;
  nonce: string;
  action: string;
  data?: FormData | null;
};

export const requestAvatarAction = async ({
  endpoint,
  nonce,
  action,
  data,
}: AvatarRequestPayload): Promise<any> => {
  const formData = data ?? new FormData();
  formData.append('action', action);
  formData.append('security', nonce);
  formData.append('context', 'frontend');

  const response = await fetch(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Avatar action failed (${response.status})`);
  }

  return response.json();
};
